import "slick-carousel";
import "./menu";
import "./product-sliders";
import "./product-sticky-form";
import "./test-freaks";
import "./slick";
import "./bPopup";

import { cookiesEnabled } from "@shopify/theme-cart";

const $win = $(window);

$(".footer-bottom .scroll-top").on("click", function(e) {
  e.preventDefault();
  $("html,body").animate({
    scrollTop: 0
  });
});

$(".menu-toggle").on("click", function() {
  const $this = $(this);
  $this.toggleClass("clicked");
  $("body").toggleClass("reveal-menu");
});

$(".footer__top .widget--navigation h4").on("click", function() {
  const $this = $(this);
  if ($win.width() < 768) {
    $this.parent().toggleClass("active").find(".menu").slideToggle();
  }
});

$(".mobile-nav .menu-item-has-children > a").on("click", function(e) {
  e.preventDefault();
  const $this = $(this);
  $this.parent().find(".dropdown:eq(0)").addClass("active");
});

$(".mobile-nav").on("click", ".dropdown.active > h2", function() {
  const $this = $(this);
  $this.parent().removeClass("active");
});

$(".product__tabs .tab__links li a").on("click", function(e) {
  e.preventDefault();
  const $li = $(this).parent();
  const liIndex = $li.index();
  $li.addClass("current").siblings().removeClass("current");
  $(".product__tabs .tab").eq(liIndex).addClass("active").siblings(".tab").removeClass("active");
});

$(".read-more").on("click", function() {
  $("html,body").animate({
    scrollTop: $(".product__tabs").offset().top
  });
});

$(document).mouseup(function(e) {
  if ($win.width() > 1080) {
    var container = $(".nav");

    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".menu-deep-1, .more-menu").fadeOut(100);
      $(".nav .active").removeClass("active");
    }
  }
});

$(".link-forgot-password.login").on("click", function() {
  $(".form-login").hide();
  $(".form-recover-password").show();
});
$(".link-forgot-password.recover").on("click", function() {
  $(".form-login").show();
  $(".form-recover-password").hide();
});

/**
* -------------------------
* CALL TO ORDER POPUP
* -------------------------
*/

$(function() {
  $(".button-cto").bind("click", function(e) {
    console.log("test");
    e.preventDefault();

    $(".marketing-popup").bPopup({
      positionStyle: "fixed",
      closeClass: "modal__close"
    });
  });
});

/**
* -------------------------
* PRODUCT OPTION POPUPS
* -------------------------
*/

$(function() {
  $(".popup-trigger").bind("click", function(e) {
    var target = $(this).data("popup-target");
    console.log(target);
    e.preventDefault();

    $(target).bPopup({
      positionStyle: "fixed",
      closeClass: "modal__close"
    });
  });
});

/**
 * -------------------------
 * Apply a specific class to the html element for browser support of cookies
 * -------------------------
 */

if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies");
}



// WEBPACK FOOTER //
// ./../src/assets/js/main.js